import Shelf from "./shelf/shelf.component";
import SearchForm from "./searchForm/SearchForm";

// Parent Inventory.tsx
const InventorySearchForm = ({
  productNumberParent,
}: {
  productNumberParent: any;
}) => (
  <Shelf mobile="68" tablet="61" desktop="55">
    <SearchForm productNumberParent={productNumberParent} />
  </Shelf>
);

export default InventorySearchForm;
